import React, { useContext } from 'react';
import { isMobile } from "react-device-detect";
import { ButtonGroup } from "@blueprintjs/core";

import Facebook from 'assets/img/facebook.svg';
import Twitter from 'assets/img/twitter.svg';
import Linkedin from 'assets/img/linkedin.svg';
import Email from 'assets/img/email.svg';

import LocaleContext from 'contexts/locale-context';
import NotificationContext from 'contexts/notification-context';

import shareEmail from 'actions/share-email';

import AnchorButton from 'components/anchor-button';
import Button from 'components/button';

import withContactForm from 'hoc/withContactForm';

import './index.css';

const getTwitterLink = url => {
    const text = '';
    const hashtags = 'midrive';
  
    return `https://twitter.com/intent/tweet?url=${url}&text=${text}&hashtags=${hashtags}`;
}
  
const getLinkedInLink = url => {
    return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
}

const getFacebookLink = url => {
    return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
}


const Socials = ({ downloadLink, openContactForm, transferId, password }) => {
    const { translations } = useContext(LocaleContext);
    const { setNotification } = useContext(NotificationContext);

    const jsTranslations = translations.js;

    const onEmail = () => {
        openContactForm({ transferId }, onSubmit)
    };

    const onSubmit = async ({ emails, name, message } = {}) => {
        const payload =  {
            recipient_emails: emails
          };
      
        if (name) payload.sender_name = name;
        if (message) payload.message = message;
      
        try {
            const resp = await shareEmail(transferId, payload, password)
      
            if (resp.status < 400) {
                setNotification({ message: `${jsTranslations.email_sent}!`, type: 'success'});
                return { success: true };
            } else {
                setNotification({ message: jsTranslations.something_went_wrong, type: 'danger' })
                return { success: false };
            }
        } catch(e) {}
    }

    const showMessage = !isMobile;

    return (
       <>
            <div className='socials__icons'>
                <ButtonGroup fill>
                    <Button
                        icon={<img onClick={onEmail} className='email' alt='email icon' src={Email}/>}
                        onClick={onEmail}
                        btnType='none'
                    >
                        {showMessage && `${jsTranslations.share_via_email}`}
                    </Button>
                    <AnchorButton
                        href={getFacebookLink(downloadLink)}
                        target="popup"
                        icon={<img alt='facebook icon' src={Facebook}/>}
                        btnType='none'
                    >
                        {showMessage && `${jsTranslations.share_on_fb}`}
                    </AnchorButton>
                    <AnchorButton
                        href={getTwitterLink(downloadLink)}
                        target="popup"
                        btnType='none'
                        icon={<img alt='twitter icon' src={Twitter}/>}
                    >
                        {showMessage && `${jsTranslations.share_on_twitter}`}
                    </AnchorButton>
                    <AnchorButton
                        href={getLinkedInLink(downloadLink)}
                        target="popup"
                        btnType='none'
                        icon={<img alt='linkedin icon' src={Linkedin}/>}
                    >
                        {showMessage && `${jsTranslations.share_on_linkedin}`}
                    </AnchorButton>
                </ButtonGroup>
            </div>
       </>
    );
};

export default withContactForm()(Socials);